import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
      component: () => import('@/components/layout/index'),
      children: [{
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index'),
        meta: {
          btnType: 'loginInfo',
          title: '首页',
          notLogin: true,
        }
      }, {
        path: '/help',
        name: 'help',
        component: () => import('@/views/index/help'),
        meta: {
          btnType: 'back',
          title: '报名流程',
          notLogin: true,
        }
      }, {
        path: '/help2',
        name: 'help2',
        component: () => import('@/views/index/helpQZ'),
        meta: {
          btnType: 'back',
          title: '报名流程',
          notLogin: true,
        }
      }, {
        path: '/intro',
        name: 'intro',
        component: () => import('@/views/introduction/index'),
        meta: {
          btnType: 'index',
          title: '大赛介绍',
          notLogin: true,
        }
      }, {
        path: '/signUp',
        name: 'signUp',
        component: () => import('@/views/signUp/index'),
        meta: {
          btnType: 'back',
          title: '报名'
        }
      }, {
        path: '/my',
        name: 'my',
        component: () => import('@/views/my/index'),
        meta: {
          btnType: 'index',
          title: '我的'
        }
      }, {
        path: '/works',
        name: 'works',
        component: () => import('@/views/works/index'),
        meta: {
          btnType: 'index',
          title: '我的作品',
          keepAlive: true,
        }
      }, {
        path: '/workDetail',
        name: 'workDetail',
        component: () => import('@/views/works/workInfo'),
        meta: {
          btnType: 'back',
          title: '作品详情'
        }
      }, {
        path: '/updateWork',
        name: 'updateWork',
        component: () => import('@/views/updateWork/index'),
        meta: {
          btnType: 'quit',
          title: '修改作品'
        }
      }, {
        path: '/judge',
        name: 'judge',
        component: () => import('@/views/judge/judgeList/index'),
        meta: {
          btnType: 'back',
          title: '作品列表',
          keepAlive: true,
        }
      }, {
        path: '/judgeDetail',
        name: 'judgeDetail',
        component: () => import('@/views/judge/judgeList/judgeInfo'),
        meta: {
          btnType: 'back',
          title: '作品详情'
        }
      }, {
        path: '/match',
        name: 'match',
        component: () => import('@/views/match/index'),
        meta: {
          title: "比赛",
          btnType: 'back',
          keepAlive: true,
        }
      }, {
        path: '/matchDetail',
        name: 'matchDetail',
        component: () => import('@/views/match/award'),
        meta: {
          title: "比赛详情",
          btnType: 'back',
        }
      }]
    }, {
      path: '*',
      redirect: '/',
    },

  ]
})


router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (!to.meta.notLogin) {
    let token = localStorage.getItem('loginToken') || '';
    let timestamp = (new Date()).getTime();
    let expires = localStorage.getItem('tokenExpires') || 0;
    if (token && expires > timestamp) {
      next()
    } else {
      localStorage.removeItem('loginToken')
      localStorage.removeItem('userInfo')
      next('/')
      location.reload()
    }
  } else {
    next()
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js